// extracted by mini-css-extract-plugin
export default {"zoomModal":"K1-z"};